<div class="profile-container">
    <div class="">
        <div class="profile-content">
         
            <div class="personal-details">
          
                <div class="header-block">
                    <div class="header-title">
                      <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                          <div class="search">
                          <form autocomplete="off" >
                              <input type="text" (keyup.enter)="getAllMaintenanceSchedulesByWildSearch()" [ngModelOptions]="{standalone: true}" placeholder="search" [(ngModel)]="searchFilter">
                          </form>
                          <i class="bi bi-search" (click)="getAllMaintenanceSchedulesByWildSearch()"></i>
                      </div>
                        <button data-toggle="modal" title="Add" data-target="#deviceModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                      <div class="filter-icon">
                          <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                      </div>
                    </div>
                </div>
                <table class="table table-striped">
                    <thead>
                        <tr>

                        <th style="width: 10%;">{{ 'maintenance-schedule.assetId' | translate }}</th>
                        <th style="width: 20%;">{{ 'maintenance-schedule.assetName' | translate }}</th>
                        <th style="width: 25%;">{{ 'maintenance-schedule.maintenanceType' | translate }}</th>
                        <th style="width: 15%;">{{ 'maintenance-schedule.frequency' | translate }}</th>
                        <th style="width: 15%;">{{ 'maintenance-schedule.nextDueDate' | translate }}</th>
                        <!-- <th style="width: 15%;">Past Performed</th> -->

                        <th style="width: 15%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" id="{{list.id}}" [ngClass]="{ 'delete-highlight': list.scheduleId == recordId }" *ngFor="let list of maintenanceScheduleList | paginate : {
                          itemsPerPage: tableSize,
                          currentPage: page,
                          totalItems: count
                        }  ;let i = index">
  
                        <p style="width: 10%;">{{list.assetId}}</p>
                        <p style="width: 20%;">{{list.assetName || '--'}}</p>
                        <p style="width: 25%;" title="">{{getMaintenanceType(list.maintenanceType)}}</p>
                        <p style="width: 15%;">{{list.frequency || '--'}}</p>
                        <p style="width: 15%;">{{list.nextDueDate | date}}</p>
                        <!-- <p style="width: 15%;">{{list.lastPerformed  | date}}</p> -->

                    
                        <p class="action-buttons" style="width: 15%;padding-left: 25px;">
                          <i data-toggle="modal" title="View" (click)="getMaintenanceScheduleById(list.scheduleId)" data-target="#viewModal" class="bi bi-eye-fill"></i>
                          <i (click)="selectDelete(list.id,list)" title="Delete" class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i>

                        </p>
                    </div>
                </div>
  
  
                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
  
                <div class="loader" *ngIf="!isLoading && maintenanceScheduleList.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>
  
                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                    [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                    </p-paginator>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalDelete" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleteMaintenanceSchedule()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="deviceModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'maintenance-schedule.headings.add' | translate }}
          <span data-dismiss="modal" (click)="remove()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="addForm">
          <div class="form-group">
              <label>{{ 'maintenance-schedule.assetName' | translate }} <span class="required">*</span></label>
              <select name="" id="" formControlName="assetId" class="form-control">
                <option value="" selected disabled> -- select asset --</option>
                <option value="{{list.objectInfoId}}" *ngFor="let list of objectInfoList">{{list.givenName}}</option>
              </select>
          </div>
     
             <div class="check-box">
                <p> {{ 'maintenance-schedule.title' | translate }} </p>
            </div>

            <div class="maintenance-schedule-block">
              <div class="maintenance-schedule">

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.description' | translate }} <span class="required">*</span></label>
                  <textarea name="" formControlName="description" class="form-control" id=""></textarea>
                </div>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.maintenanceType' | translate }} <span class="required">*</span></label>
                  <select name="" id="" formControlName="maintenanceType" class="form-control">
                    <option value="" selected disabled> -- select maintenance type --</option>
                    <option value="{{list.value}}" *ngFor="let list of maintenanceType">{{list.key}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.frequency' | translate }} <span class="required">*</span></label>
                  <select name="" id="" formControlName="frequency" class="form-control">
                    <option value="" selected disabled> -- select frequency type --</option>
                    <option value="{{list.value}}" *ngFor="let list of frequencyType">{{list.key}}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>{{ 'maintenance-schedule.nextDueDate' | translate }} <span class="required">*</span></label>
                  <input type="date" [min]="todayDate" class="form-control" formControlName="nextDueDate">
                </div>
              </div>
            </div>

        
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" (click)="remove()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="addMaintenanceSchedule()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- <div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Edit Asset Depreciation
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="updateForm">
                    <div class="form-group">
                        <label>Method Name <span class="required">*</span></label>
                        <input formControlName="methodName" type="text" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>Description</label>
                        <textarea formControlName="methodDescription" class="form-control" name="" id=""></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalUpdate" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="updateAssetDepreciationMethod()" class="btn btn-primary">Update</button>
                </div>
            </div>
        </div>
    </div>
</div> -->


<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'maintenance-schedule.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data" *ngFor="let viewData of singleObjectInfoData">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>{{ 'maintenance-schedule.scheduleId' | translate }} :</label>
                <p>{{viewData.scheduleId || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'maintenance-schedule.assetId' | translate }} :</label>
                <p>{{viewData.assetId || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'maintenance-schedule.assetName' | translate }} :</label>
                <p>{{viewData.assetName || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'maintenance-schedule.description' | translate }} :</label>
                <p>{{viewData.description || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'maintenance-schedule.maintenanceType' | translate }} :</label>
                <p>{{getMaintenanceType(viewData.maintenanceType) || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'maintenance-schedule.frequency' | translate }} :</label>
                <p>{{viewData.frequency || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'maintenance-schedule.nextDueDate' | translate }} :</label>
                <p>{{viewData.nextDueDate | date}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'maintenance-schedule.lastPerformed' | translate }} :</label>
                <p>{{viewData.lastPerformed || '--'}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>